import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { logrocketPlugin } from '@/services/logrocket';

import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

import project from './modules/project';
import subscription from './modules/subscription';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    project,
    subscription,
  },
  plugins: [createPersistedState(), logrocketPlugin],
});
